import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Dialog: Einflussgröße löschen.
 *
 * Technischer Extract aus App.jsx (Plan A): UI/Keys 1:1.
 */
function EinflussDeleteDialog({ open, name, onConfirm, onCancel }) {
  const { t } = useTranslation();
  if (!open) return null;

  return (
    <div
      className="dialog-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onCancel();
      }}
    >
      <div className="dialog-modal" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h3>⚠️ {t('dialog.row_delete.title')}</h3>
        </div>
        <div className="dialog-content">
          <p>{t('config.einflussdb.confirm_delete', { name })}</p>
        </div>
        <div className="dialog-actions">
          <button className="btn btn-secondary" onClick={onCancel} type="button">
            {t('dialog.cancel')}
          </button>
          <button className="btn btn-danger" onClick={onConfirm} type="button">
            {t('dialog.delete')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default EinflussDeleteDialog;

